import workJa from '@/assets/images/top/ja/usecase/animation-work.webp';
import studyJa from '@/assets/images/top/ja/usecase/animation-study.webp';
import healthJa from '@/assets/images/top/ja/usecase/animation-health.webp';
import hobbyJa from '@/assets/images/top/ja/usecase/hobby1.png';
import familyJa from '@/assets/images/top/ja/usecase/family1.png';
import workEn from '@/assets/images/top/en/usecase/animation-work.webp';
import studyEn from '@/assets/images/top/en/usecase/animation-study.webp';
import healthEn from '@/assets/images/top/en/usecase/animation-health.webp';
import hobbyEn from '@/assets/images/top/en/usecase/hobby1.png';
import familyEn from '@/assets/images/top/en/usecase/family1.png';
import { isJapaneseLocale } from '@/utils/isJapaneseLocale';

export type TopUsecaseAsset = {
    id: string;
    image: string;
};

/**
 * ユースケースのメディア情報（文言は i18n から取得）
 */
export function getTopUsecaseAssets(i18nLanguage: string | undefined): TopUsecaseAsset[] {
    const ja = isJapaneseLocale(i18nLanguage);
    return [
        {
            id: 'work',
            image: ja ? workJa : workEn,
        },
        {
            id: 'learning',
            image: ja ? studyJa : studyEn,
        },
        {
            id: 'wellness',
            image: ja ? healthJa : healthEn,
        },
        {
            id: 'hobby',
            image: ja ? hobbyJa : hobbyEn,
        },
        {
            id: 'family',
            image: ja ? familyJa : familyEn,
        },
    ];
}
